<template>
    <v-content>
        <v-container>
                <v-card flat class="pa-3">
                    <v-layout row wrap>
                        <v-flex md12>
                            <v-layout row wrap>
                                <v-flex md6>
                                    <amplify-photo-picker v-bind:photoPickerConfig="photoPickerConfig"></amplify-photo-picker>
                                </v-flex>
                                <v-flex md6>
                                    <amplify-s3-image class="pt-5" v-bind:imagePath="icon" v-bind:key="icon"></amplify-s3-image>
                                </v-flex>
                            </v-layout>
                            <input type="hidden" v-model="icon">
                            <v-form ref="form" v-model="valid" lazy-validation>
                                <v-select v-model="role" :items="roles" label="Role"></v-select>
                                <v-text-field v-model="title" :rules="titleRules" label="Title" required></v-text-field>
                                <v-text-field v-model="link" :rules="linkRules" label="Link" required></v-text-field>
                                <v-text-field v-model="des" :rules="desRules" label="Description" required></v-text-field>
                            </v-form>
                        </v-flex>
                    </v-layout>
                    <v-layout row justify-end>
                            <v-btn class="ma-0 my-3 mr-3" large color="info" @click="clear()">Clear</v-btn>
                            <v-btn class="ma-0 my-3" large color="info" :disabled="!icon" @click="postForm()">Submit</v-btn>
                    </v-layout>
                </v-card>
        </v-container>
    </v-content>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { AmplifyEventBus } from 'aws-amplify-vue';
    import latinize from 'latinize';
    export default {
        data() {
            return {
                valid: true,
                roles: ['Manager', 'Teacher', 'Student'],
                imageName: '',
                valid: false,
                role: 'Manager',
                icon: '',
                name: '',
                title: '',
                titleRules: [
                    v => !!v || 'Title is required',
                ],
                link: '',
                linkRules: [
                    v => !!v || 'Link is required',
                ],
                des: '',
                desRules: [
                    v => !!v || 'Description is required',
                ],
                photoPickerConfig: {
                    path: 'icon',
                    header: "Icon upload",
                }
            }
        },

        created() {
            AmplifyEventBus.$on('fileUpload', (data) => {
                this.icon = data;
            });
        },
        
        methods: {
            postForm() {
                if (this.$refs.form.validate()) {
                    const pack = {
                        relationId: "techkids",
                        id: "1544814915334",
                        role: this.role.toLowerCase(),
                        dataDetails: {},
                        descriptions: this.des,
                        link: this.link,
                        metaData: {
                            icon: this.icon,
                            name: latinize(this.title).toLowerCase().replace(new RegExp(' ', 'g'), '')
                        },
                        title: this.title,
                        widgets: {}
                    };
                    this.callAppAdd(pack);
                    this.$router.push(`/app/${this.role.toLowerCase()}`);
                }
            },

            clear () {
                this.$refs.form.reset();
            },
            ...mapActions('users', ['callAppAdd'])
        }
    }
</script>

<style scoped>

</style>